import Command from "@ckeditor/ckeditor5-core/src/command";
import { CkeditorConstants } from "../../src/utils";

const {
  helperAttributes: { TRACK_CHANGES_EDITING, REMOVE_INSERTEDKEYWORD_DISCARD, RESOURCE },
  command: { DELETE_KEYWORDS_LINK },
  COMMANDS: { CMD_TRACK_CHANGES },
  htmlAttributes: { ID, CLASS },
  class: { WK_KEYWORD_REF },
  trackchangesMarkup: { SUGGESTION },
  elementClass: { suggestion_marker, suggestion_deletion_marker },
  htmlElement: { SPAN, KEYWORD_SPAN }
} = CkeditorConstants;

export default class KeywordDefinitionDeleteCommand extends Command {
  /*
  Description: Inserts a keyword element span in editor
  Params: Object of label id and definition id of the keyword
  */
  execute(data) {
    const { model, commands, plugins, editing } = this.editor
    const range = model.createRangeIn(model.document.getRoot());
    const foundItems = [];
    const unwrapFlag = data[1];
    for (const id of data[0]) {
      foundItems.push(...([...range.getItems({ ignoreElementEnd: true })].filter((item)=> item.getAttribute(ID) === id && item.getAttribute(CLASS) === WK_KEYWORD_REF)))
    }
    const isEnabled = commands.get(CMD_TRACK_CHANGES).value;
    const trackChangesEditing = plugins.get(TRACK_CHANGES_EDITING);
    model.change((writer) => {
      foundItems.forEach((item) => {
        const range = writer.createRangeOn(item);
        let keywordTxt = '';
        if (item._children &&
          item._children._nodes &&
          item._children._nodes[0] &&
          typeof item._children._nodes[0]._data === "string") {
          keywordTxt = item._children._nodes[0]._data;
        }
        if (isEnabled) {
          const editingRootDomElement = editing.view.domRoots.get("main");
          const selectedKeywordId = item.getAttribute(ID);
          const elementToRemove = editingRootDomElement.querySelector(
            `[id='${selectedKeywordId}']`
          );
          if (elementToRemove &&
            elementToRemove.querySelector(`.${suggestion_marker}`)
            && !elementToRemove.querySelector(`.${suggestion_deletion_marker}`)) {
            this.removeKeywordOnSuggestion(
              elementToRemove,
              trackChangesEditing,
              foundItems,
              unwrapFlag
            );
          } else {
            if(unwrapFlag){
              trackChangesEditing.markDeletion(range, null, {
                commandParams: {
                  keywordText: keywordTxt,
                  removeKeywordFromTrackChanges: true,
                },
                commandName: DELETE_KEYWORDS_LINK,
              })
            }else{
              trackChangesEditing.markDeletion(range)
            }
          }

        } else {
          const pos = writer.createPositionBefore(item)
          writer.remove(range);
          let documentFragment = writer.createDocumentFragment();
          for (const selection of item.getChildren()) {
            const clone = writer.cloneElement(selection);
            writer.append(clone, documentFragment);
          }
          if(unwrapFlag === undefined || unwrapFlag === true){
            model.insertContent(documentFragment, pos)
          }
        }

      });
    });
  }

  /**
   * This method is used to unwrap keyword which has suggestion on it on Discard or delete.
   * @param {Element} elementToRemove 
   * @param {Track changes command} trackChangesEditing 
   * @param {Total Items found to update the document Reference ID } foundItems 
   */
  removeKeywordOnSuggestion(elementToRemove, trackChangesEditing, foundItems, unwrapFlag) {
    const eleMarkerSuggestion = elementToRemove.querySelector(`.${suggestion_marker}`);
    if (eleMarkerSuggestion) {
      const keywordId = elementToRemove.getAttribute(RESOURCE).split('/').pop();
      const docRefId = elementToRemove.getAttribute(ID);
      const dataSuggestionChild =
        eleMarkerSuggestion.getAttribute(SUGGESTION);
      this.editor.model.change((writer) => {
        const suggestion =
          trackChangesEditing.getSuggestion(dataSuggestionChild);
        let eleToRemove = null;
        const range = this.editor.model.createRangeIn(
          this.editor.model.document.getRoot()
        );
        for (const item of range.getItems({ ignoreElementEnd: true })) {
          if ((item.name === KEYWORD_SPAN || item.name === SPAN) && item.getAttribute(CLASS) === WK_KEYWORD_REF && item.getAttribute(ID) === docRefId) {
            eleToRemove = item;
          }
        }
        const [markerName] = suggestion.getMarkerNames();
        writer.removeMarker(markerName);
        
        if(unwrapFlag === undefined || unwrapFlag === true){
          writer.unwrap(eleToRemove);
        } else{
          writer.remove(eleToRemove) ;
        }
      });
      this.editor.fire(REMOVE_INSERTEDKEYWORD_DISCARD, { 'keywordId': keywordId, 'docReferenceId': foundItems.length === 1 ? docRefId : 'all' });
    }
  }
}